/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

function GuillaumeLeger(props) {
  const title = 'Guillaume Leger';
  const content =
    'Chief Financial Officer & Executive General Manager, Finance';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={content}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Guillaume Leger'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/guillaume-leger-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText
            fontSize={FONT_SIZE.LARGE}
            css={`
              text-align: justify;
            `}
          >
            Guillaume joined Latitude as Chief Financial Officer & Executive
            General Manager, Finance in June 2025. Before Latitude, Guillaume
            was CFO of international litigation funder Omni Bridgeway (ASX: OBL)
            based in New York where he led the company’s investor relations,
            capital raising and oversaw all financial operations and reporting.
            Before this, he held leadership roles including Group Controller of
            Alimentation CoucheTard Inc. (TSX: ATD), a Fortune 200 company.
          </StyledText>
          <StyledText
            fontSize={FONT_SIZE.LARGE}
            css={`
              text-align: justify;
            `}
          >
            Guillaume was also CFO at Citigroup in Hong Kong after holding
            senior positions across Citigroup Inc.’s business in North America,
            Asia, New Zealand, Australia and Brazil.
            <br />
            <br />
            Guillaume holds a Graduate Diploma in Public Accounting from HEC
            Montréal and obtained his Bachelor in Accounting Sciences from
            Université du Québec à Montréal (UQAM).
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
}
export default GuillaumeLeger;
